import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { includes } from 'lodash-es';
import { SimpleToggle, Typography } from '@dev/ee-components';
import { FormPageTypeEnum, FormSettingsEnum } from '@dev/ee-api/ee-api-models';

import { getFormCreatorStore } from '@/store/formCreator/actions';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { Divider } from '@/assets/Divider';
import { ToggleWrapper, TitleWrapper } from './styles';
import { DoubleOptInContentSection } from './components/DoubleOptInContentSection';

export const Step3Content = (): JSX.Element => {
    const { t } = useTranslation();
    const { formObject } = useSelector(getFormCreatorStore);
    const isDoubleOptIn = includes(formObject?.FormSettings, FormSettingsEnum.AddDoubleOptIn);
    const activationEmailTemplate = formObject?.ActivationTemplateName;
    const formPageType = formObject?.FormPageType;
    const activationSite = formObject?.DoubleOptInPage;
    const formSubmitPage = formObject?.FormSubmitPage;
    const formAlreadySubscribedPage = formObject?.FormAlreadySubscribedPage;
    const { isPilotPlan } = useCurrentPlanStatus();

    return (
        <>
            <Typography variant="h3">{t('doubleoptinconfirmation')}</Typography>
            <ToggleWrapper>
                <SimpleToggle
                    id="forms-double-opt-in-toggle"
                    value="doubleOptIn"
                    label={t('senddoubleoptinconfirmationemail')}
                    checked={isDoubleOptIn}
                    disabled
                />
            </ToggleWrapper>
            {isDoubleOptIn && !isPilotPlan && (
                <DoubleOptInContentSection
                    activationEmailTemplate={activationEmailTemplate}
                    activationSite={activationSite}
                    formPageType={formPageType}
                />
            )}
            <Divider marginTop={32} marginBottom={32} />
            <TitleWrapper>
                <Typography variant="h3">{t('contactsubmitsform')}</Typography>
            </TitleWrapper>
            {formPageType?.[1] === FormPageTypeEnum.DefaultFormSubmitPage && (
                <Typography variant="body1">{t('defaultpage')}</Typography>
            )}
            {formPageType?.[1] === FormPageTypeEnum.LandingPageFormSubmitPage && (
                <Typography variant="body1">{`${t('landingpage')}: ${formSubmitPage}`}</Typography>
            )}
            {formPageType?.[1] === FormPageTypeEnum.ExternalWebsiteFormSubmitPage && (
                <Typography variant="body1">{`${t('externalwebsite')}: ${formSubmitPage}`}</Typography>
            )}
            <Divider marginTop={32} marginBottom={32} />
            <TitleWrapper>
                <Typography variant="h3">{t('contacthaspreviouslysubscribed')}</Typography>
            </TitleWrapper>
            {formPageType?.[2] === FormPageTypeEnum.DefaultFormSubscribedPage && (
                <Typography variant="body1">{t('defaultpage')}</Typography>
            )}
            {formPageType?.[2] === FormPageTypeEnum.LandingPageFormSubscribedPage && (
                <Typography variant="body1">{`${t('landingpage')}: ${formAlreadySubscribedPage}`}</Typography>
            )}
            {formPageType?.[2] === FormPageTypeEnum.ExternalWebsiteFormSubscribedPage && (
                <Typography variant="body1">{`${t('externalwebsite')}: ${formAlreadySubscribedPage}`}</Typography>
            )}
        </>
    );
};
